<template lang="pug">   
transition(name="slide-fade")
    v-card
        v-card-title(class="elevation-10") 
                h4 Reportes
                h5   
        v-card                 
            v-container(fluid)                                  
                ul(class="nav nav-tabs" id="myTab" role="tablist"  style="background-color : transparent!important;")
                        li(class="nav-item" v-if="tablaDocType" v-for="item of tablaDocType.filter(b=> b.Active==1)")
                            a( v-bind:class="[{active : item.Select},'nav-link']" href="#" @click="reset(item), InfoDocTypeSelect=item "   ) {{item.Name}}   
            informe(v-if="InfoDocTypeSelect.Name",:apiWeb='_api()',:InfoSelect.sync="InfoDocTypeSelect")

</template>
<script>  
import apiWeb from "../../../api/apiSLC.js"
import modelDocuType from "../../../models/documentType.js"
import informe from "./components/informes.vue" 


export default {
    components:{  
        informe
    },
    data(){
        return{ 
            IsShowModalDocType:false,
            IsShowModalField:false,
            parameterViewDocuType:Object.assign({}, modelDocuType.parameterView),
            InfoDocTypeSelect:{},
            tablaDocType:[]
        }
    },
    mounted(){
        this.setValueInit()
    },
    methods:{
        _api(){
            return apiWeb;
        },
        reset(item){
            this.tablaDocType.forEach(element => {
                if(item.Name==element.Name){
                    element.Select=true 
                }
                else{
                    element.Select=false
                }
            });
          
        },
        setValueInit(){
            this.selectEnterprise=this.$info.idEnterprise   
            this.List_Info()
        },
        List_Info(){   
            this.parameterViewDocuType.IdEnterprise=this.selectEnterprise 
            apiWeb.post("DocumentType/DocumentType_View",this.parameterViewDocuType)
                    .then(result=>{
                                if(result.status==0){
                                    this.tablaDocType=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
    }
}
</script>
<style scoped>
    .nav {
        background-color: transparent!important;
    }

    .slide-fade-enter-active {
      transition: all .5 ease;
    }

    .slide-fade-leave-active {
      transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to{
      transform: translateX(10px);
      opacity: 0;
    } 
</style>